'use client'

import * as React from 'react'
import { SidebarProvider } from '@/components/ui/sidebar'
import { RightSidebarProvider } from '@/components/ui/right-sidebar'

interface LayoutProvidersProps {
    children: React.ReactNode
}

/**
 * Client component that handles all layout-related context providers.
 * Extracted for better code organization and potential future optimization.
 */
export function LayoutProviders({ children }: LayoutProvidersProps) {
    return (
        <SidebarProvider>
            <RightSidebarProvider>{children}</RightSidebarProvider>
        </SidebarProvider>
    )
}
